/**
 * Pièce jointe d'un dossier (entreprise ou institution).
 *
 * Forme unique : celle que `FileUpload` écrit après l'envoi Cloudinary et que
 * customer-service stocke (`DocumentFileDto` : url, name, type, size,
 * uploadedAt). `id` et `publicId` sont propres au client et voyagent dans la
 * colonne JSON ; les pièces plus anciennes peuvent ne pas les avoir.
 */
export interface DocumentFile {
  /** Identifiant local du fichier (absent des pièces anciennes). */
  id?: string;
  /** URL Cloudinary (ou CDN) du fichier. */
  url: string;
  /** Nom du fichier d'origine. */
  name: string;
  /** Type MIME. */
  type?: string;
  /** Taille en octets. */
  size?: number;
  /** Identifiant Cloudinary, pour une suppression ultérieure côté serveur. */
  publicId?: string;
  /** Date d'envoi, ISO 8601. */
  uploadedAt?: string;
}

/** Clé stable d'une pièce : son identifiant, sinon son URL. */
export const documentKey = (doc: DocumentFile): string => doc.id ?? doc.url;
